import { axiosHelper } from 'Services/AxiosHelper';
import { OnGetCardListModel, ResendCustomerCardModel } from 'Models';
import { onGetCardListBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';
import { resendCustomerCardBodyData } from 'Config/ServiceConfig';

const command = 'RI.ResendCustomerCard';

const resendCustomerCard = async (params: resendCustomerCardBodyData): Promise<ResendCustomerCardModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default resendCustomerCard;
